import {useCallback, useEffect, useState} from 'react';
import {DataTable} from '../../common/DataTable/DataTable';
import {MainViewContainer} from '../../common/MainViewContainer/MainViewContainer';
import {useTenant} from '../../providers/api/useTenant';
import {tenantCols} from './TenantViewData';
import {TenantData} from '../../types/types';
import {Box, Button} from '@mui/material';
import {useNavigate, useLocation} from 'react-router-dom';
import {Toast} from '../../common/Toast/Toast';
import {GridCellParams} from '@mui/x-data-grid';
import {updateTenant} from '@digistaff/business';
import {app} from '../../providers/Account';
import {Confirmation} from '../../common/Alerts/Confirmation';

export const TenantsView = () => {
  const {listAllTenants} = useTenant();
  const [tenants, setTenants] = useState<TenantData[]>([]);
  const [loading, setLoading] = useState(true);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const navigate = useNavigate();
  const {state} = useLocation();
  const [showToast, setShowToast] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [tenantId, setTenantId] = useState('');
  const [tenantName, setTenantName] = useState('');

  const getData = useCallback(async () => {
    setLoading(true);
    const tenantList: TenantData[] = await listAllTenants();
    setTenants(tenantList);
    setLoading(false);
  }, [listAllTenants]);

  const handleDelete = async (rowData: GridCellParams) => {
    setTenantId(rowData.row.id);
    setTenantName(rowData.row.name);
    setShowConfirmation(true);
  };

  const handleAction = async () => {
    try {
      setUpdating(true);
      const payload = {status: 'mark_as_deleted'};
      await updateTenant(app, tenantId, payload)
        .then(() => getData())
        .finally(() => {
          setUpdating(false);
          setShowConfirmation(false);
        });
    } catch (err) {
      console.error('Failed to delete tenant:', err);
    }
  };
  useEffect(() => {
    if (state?.created) {
      setShowToast(true);
    }
  }, [state]);

  return (
    <MainViewContainer title="Tenants">
      <Box sx={{display: 'flex', justifyContent: 'flex-end', mb: 1.5}}>
        <Button variant="outlined" onClick={() => navigate('/tenants/add')}>
          Add Tenant
        </Button>
      </Box>
      <DataTable
        height={'65vh'}
        rows={tenants}
        columns={tenantCols}
        loading={loading}
        rowCount={tenants.length}
        getData={getData}
        handleCellClick={cell => {
          if (cell.field === 'mark_as_deleted') {
            handleDelete(cell);
          }
        }}
      />
      <Toast
        open={showToast}
        handleClose={() => setShowToast(false)}
        severity="success"
        text="Tenant has been created"
        verticalPos="bottom"
        horizontalPos="center"
      />
      <Confirmation
        open={showConfirmation}
        handleClose={() => setShowConfirmation(false)}
        message={
          <>
            To confirm, type <strong>&quot;{tenantName}&quot;</strong> in the
            box below.
          </>
        }
        handleConfirm={handleAction}
        loading={updating}
        projectName={tenantName}
      />
    </MainViewContainer>
  );
};
